import React, { useEffect, useState } from 'react'
import { Tab } from './Tab'
import style from './tabs.module.scss'

export const Tabs = ({children}) => {
    const [active, setActive] = useState(children[0].props.title)

    const onClickTabItem = (tab) => {
        setActive((cur) => tab)
    }

    return (
        <div className={style.tabs}>
            <ol className={style["tab-list"]}>
                {children?.map((child, i) => {
                    const { title } = child.props

                    return (
                        <Tab 
                            activeTab={active}
                            key={i}
                            title={title}
                            onClick={onClickTabItem}
                        />
                    )
                })}
            </ol>
            <div className={style["tab-content"]}>
                {children.map((child, i) => {
                    return React.cloneElement(child, {
                        key: i,
                        hidden: child.props.title !== active ? style.hide : '',
                        // className: child.props.title !== active ? style.hide : ''
                    })
                })}
            </div>
        </div>
    )
}
